<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <app-button @click.native="onShowModal">Create order</app-button>
        <app-input
          v-model="search"
          @input.native="onOrdersSearch"
          class="input--300"
          type="search"
          placeholder="Search by id"
          name="search"
        />
        <app-select
          @input="onFilterProducts"
          v-model="filter_suppliers"
          :options="supplier_options"
          :reduce="item => item.id"
          placeholder="Supplier"
          class="select--300"
        />
      </app-cells>
      <app-cells><h2 class="title">Drafts</h2></app-cells>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
        :class="{ 'table-default--loading': table_draft_preloader }"
      >
        <template #h__id>
          <div class="table-default__left">ID</div>
        </template>
        <template #h__supplier>
          <div class="table-default__left">Supplier</div>
        </template>
        <template #id="{ row }">
          <div class="table-default__left">
            <router-link :to="{name: 'product-storage-order-detail', params: {id: row.id }}" class="table-default__link-border">
              Order - {{ row.id }}
            </router-link>
          </div>
        </template>
        <template #date="{ row }">
          {{ dateFormat(row.date) }}
        </template>
        <template #supplier="{ row }">
          <router-link
              v-if="is_general_manager || is_product_storage_manager || is_product_storage_supervisor"
              :to="{name: 'supplier-detail', params: {id: row.supplier.id }}"
              class="table-default__link-border"
          >
            {{ row.supplier.name }}
          </router-link>
          <div v-else class="table-default__left">{{ row.supplier.name }}</div>
        </template>
        <template #estimated="{ row }">
          {{ row.estimated.toLocaleString() }} TSh
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table.items.length" :page="pagination.page" />
      </app-cells>
      <template v-if="table_ready.items.length">
        <app-cells><h2 class="title">Ready to buy</h2></app-cells>
        <v-client-table
          :data="table_ready.items"
          :columns="table_ready.columns"
          :options="table_ready.options"
          class="table-default"
          :class="{ 'table-default--loading': table_ready_preloader }"
        >
          <template #h__id>
            <div class="table-default__left">ID</div>
          </template>
          <template #h__supplier>
            <div class="table-default__left">Supplier</div>
          </template>
          <template #id="{ row }">
            <div class="table-default__left">
              <router-link :to="{name: 'product-storage-order-detail', params: {id: row.id }}" class="table-default__link-border">
                Order - {{ row.id }}
              </router-link>
            </div>
          </template>
          <template #date="{ row }">
            {{ dateFormat(row.date) }}
          </template>
          <template #supplier="{ row }">
            <router-link
                v-if="is_general_manager || is_product_storage_manager || is_product_storage_supervisor"
                :to="{name: 'supplier-detail', params: {id: row.supplier.id }}"
                class="table-default__link-border"
            >
              {{row.supplier.name }}
            </router-link>
            <div v-else class="table-default__left">{{ row.supplier.name }}</div>
          </template>
          <template #estimated="{ row }">
            {{row.estimated.toLocaleString() }} TSh
          </template>
        </v-client-table>
        <app-cells position="between">
          <div>
            <paginate
              :clickHandler="onClickPaginationReady"
              v-if="pagination_ready.pages > 1"
              v-model="pagination_ready.page"
              :page-count="pagination_ready.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records :all="pagination_ready.count" :count="table_ready.items.length" :page="pagination_ready.page" />
        </app-cells>
      </template>
      <template v-if="table_cash.items.length">
        <app-cells><h2 class="title">In process (Cash)</h2></app-cells>
        <v-client-table
          :data="table_cash.items"
          :columns="table_cash.columns"
          :options="table_cash.options"
          class="table-default"
          :class="{ 'table-default--loading': table_cash_preloader }"
        >
          <template #h__select>
            <label
              v-if="table_cash.items.filter(item => !item.cash_request).length"
              class="checkbox checkbox--table"
            >
              <input
                v-model="checked_all"
                type="checkbox"
                name="checked_all"
                ref="mainCh"
              />
              <span class="checkbox__checkmark"></span>
            </label>
          </template>
          <template #h__id>
            <div class="table-default__left">ID</div>
          </template>
          <template #h__supplier>
            <div class="table-default__left">Supplier</div>
          </template>
          <template #select="{ row }">
            <label v-if="!row.cash_request" class="checkbox  checkbox--table">
              <input
                v-model="checked"
                type="checkbox"
                :value="row.id"
                :name="row.id"
              />
              <span class="checkbox__checkmark"></span>
            </label>
          </template>
          <template #id="{ row }">
            <div class="table-default__left">
              <router-link :to="{name: 'product-storage-order-detail', params: {id: row.id }}" class="table-default__link-border">
                Order - {{ row.id }}
              </router-link>
            </div>
          </template>
          <template #print="{ row }">
            <div class="table-default__controls">
              <button
                v-if="!print_preload || print_preload !== `print_cash_${row.id}`"
                @click="onPrint(row)"
                type="button"
                :disabled="!row.cash_request || print_preload"
              >
                <img src="@/assets/img/print-table-icon.svg" alt="" :style="[ !row.cash_request ? {'filter': 'grayscale(1)'} : {'filter': 'grayscale(0)'} ]">
              </button>
              <img v-show="print_preload === `print_cash_${row.id}`" src="@/assets/img/preloader-export.svg" alt="">
            </div>
          </template>
          <template #date="{ row }">
            {{ dateFormat(row.date) }}
          </template>
          <template #supplier="{ row }">
            <router-link
                v-if="is_general_manager || is_product_storage_manager || is_product_storage_supervisor"
                :to="{name: 'supplier-detail', params: {id: row.supplier.id }}"
                class="table-default__link-border"
            >
              {{ row.supplier.name }}
            </router-link>
            <div v-else class="table-default__left">{{ row.supplier.name }}</div>
          </template>
          <template #cash_request="{ row }">
            <span
              class="status-tag"
              :style="{ 'backgroundColor': row.cash_request.status.code === 'in_process' ? '#439ad1' : row.cash_request.status.code === 'completed' ? '#77b017' : '#5f5f5f' }"
              v-if="row.cash_request"
              v-tooltip="{ content: `Request ID: ${row.cash_request.id}`, placement: 'top-start', offset: 10 }"
            >
              {{ row.cash_request.status.name }}
            </span>
            <span
              v-else
              class="status-tag"
              :style="{ 'backgroundColor': '#f0c427' }"
            >
              Not requested
            </span>
          </template>
          <template #estimated="{ row }">
            {{ row.estimated.toLocaleString() }} TSh
          </template>
          <template #real="{ row }">
            {{ row.real.toLocaleString() }} TSh
          </template>
          <template #difference="{ row }">
            {{ row.difference.toLocaleString() }} TSh
          </template>
        </v-client-table>
        <app-cells position="between">
          <div>
            <paginate
              :clickHandler="onClickPaginationCash"
              v-if="pagination_cash.pages > 1"
              v-model="pagination_cash.page"
              :page-count="pagination_cash.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records :all="pagination_cash.count" :count="table_cash.items.length" :page="pagination_cash.page" />
        </app-cells>
      </template>
      <template v-if="table_bank.items.length">
        <app-cells><h2 class="title">In process (Bank)</h2></app-cells>
        <v-client-table
          :data="table_bank.items"
          :columns="table_bank.columns"
          :options="table_bank.options"
          class="table-default"
          :class="{ 'table-default--loading': table_bank_preloader }"
        >
          <template #h__id>
            <div class="table-default__left">ID</div>
          </template>
          <template #h__supplier>
            <div class="table-default__left">Supplier</div>
          </template>
          <template #id="{ row }">
            <div class="table-default__left">
              <router-link :to="{name: 'product-storage-order-detail', params: {id: row.id }}" class="table-default__link-border">
                Order - {{ row.id }}
              </router-link>
            </div>
          </template>
          <template #print="{ row }">
            <div class="table-default__controls">
              <button
                v-if="!print_preload || print_preload !== `print_bank_${row.id}`"
                @click="onPrint(row)"
                type="button"
                :disabled="print_preload"
              >
                <img src="@/assets/img/print-table-icon.svg" alt="">
              </button>
              <img v-show="print_preload === `print_bank_${row.id}`" src="@/assets/img/preloader-export.svg" alt="">
            </div>
          </template>
          <template #date="{ row }">
            {{ dateFormat(row.date) }}
          </template>
          <template #supplier="{ row }">
            <router-link
                v-if="is_general_manager || is_product_storage_manager || is_product_storage_supervisor"
                :to="{name: 'supplier-detail', params: { id: row.supplier.id }}"
                class="table-default__link-border"
            >
              {{ row.supplier.name }}
            </router-link>
            <div v-else class="table-default__left">{{ row.supplier.name }}</div>
          </template>
          <template #estimated="{ row }">
            {{ row.estimated.toLocaleString() }} TSh
          </template>
          <template #real="{ row }">
            {{ row.real.toLocaleString() }} TSh
          </template>
          <template #difference="{ row }">
            {{ row.difference.toLocaleString() }} TSh
          </template>
        </v-client-table>
        <app-cells position="between">
          <div>
            <paginate
              :clickHandler="onClickPaginationBank"
              v-if="pagination_bank.pages > 1"
              v-model="pagination_bank.page"
              :page-count="pagination_bank.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records :all="pagination_bank.count" :count="table_bank.items.length" :page="pagination_bank.page" />
        </app-cells>
      </template>
    </template>
    <div class="flying-block" :class="{ 'flying-block--show': is_show_flying_block }">
      <div class="flying-block__text">Selected orders: <span>{{ checked.length }}</span></div>
      <app-button @click.native="onPaymentCreate" ref="submitPayment">Request cash</app-button>
    </div>
    <modal
      name="client-form"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="onCloseModal" class="popup__close" type="button"></button>
        <div class="popup__title">New order</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm">
            <app-form-group v-if="!is_product_storage_storekeeper" label="Storekeeper" required>
              <app-select
                v-model="form.storekeeper"
                :options="employee_options"
                :reduce="item => item.id"
                :clearable="false"
                label="full_name"
                placeholder="Storekeeper"
                :error="$v.form.storekeeper.$error"
              />
              <template #error>
                <div v-if="$v.form.storekeeper.$dirty && !$v.form.storekeeper.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Buyer" required>
              <app-select
                v-model="form.buyer"
                :options="buyer_options"
                :reduce="item => item.id"
                :clearable="false"
                label="full_name"
                placeholder="Buyer"
                :error="$v.form.buyer.$error"
              />
              <template #error>
                <div v-if="$v.form.buyer.$dirty && !$v.form.buyer.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Supplier" required>
              <app-select
                v-model="form.supplier"
                :options="supplier_options"
                :reduce="item => item.id"
                :clearable="false"
                placeholder="Supplier"
                :error="$v.form.supplier.$error"
              />
              <template #error>
                <div v-if="$v.form.supplier.$dirty && !$v.form.supplier.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Notes" label-for="notes">
              <app-textarea
                v-model="form.note"
                id="notes"
                placeholder="Notes"
              />
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button :disabled="$v.form.$error" type="submit" ref="submit">Create order</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  getEmployeesListSearch,
  getOrderPrint,
  getOrdersProduct,
  getSuppliersProduct,
  postProductStorageCashRequests,
  postProductStorageOrder,
} from '@/http'
import debounce from 'lodash/debounce'
import { required, requiredIf } from 'vuelidate/lib/validators'
import { format, parse } from 'date-fns'

export default {
  name: 'ProductStorageOrdersActive',
  data() {
    return {
      is_loaded: false,
      search: '',
      filter_suppliers: [],
      table: {
        items: [],
        columns: ['id', 'date', 'supplier', 'estimated'],
        options: {
          headings: {
            'id': 'ID',
            'date': 'Date',
            'supplier': 'Supplier',
            'estimated': 'Est. Value',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_ready: {
        items: [],
        columns: ['id', 'date', 'supplier', 'estimated'],
        options: {
          headings: {
            'id': 'ID',
            'date': 'Date',
            'supplier': 'Supplier',
            'estimated': 'Est. Value',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_ready: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_cash: {
        items: [],
        columns: ['select', 'id', 'print', 'date', 'supplier', 'cash_request', 'estimated', 'real', 'difference'],
        options: {
          headings: {
            'select': '',
            'id': 'ID',
            'print': 'Print',
            'date': 'Date',
            'supplier': 'Supplier',
            'cash_request': 'Cash',
            'estimated': 'Est. Value',
            'real': 'Real Value',
            'difference': 'Diff. Value',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_cash: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_bank: {
        items: [],
        columns: ['id', 'print', 'date', 'supplier', 'estimated', 'real', 'difference'],
        options: {
          headings: {
            'id': 'ID',
            'print': 'Print',
            'date': 'Date',
            'supplier': 'Supplier',
            'estimated': 'Est. Value',
            'real': 'Real Value',
            'difference': 'Diff. Value',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_bank: {
        pages: 1,
        page: 1,
        count: 1,
      },
      form: {
        storekeeper: null,
        buyer: null
      },
      employee_options: [],
      buyer_options: [],
      supplier_options: [],
      checked_all: false,
      checked: [],
      is_show_flying_block: false,
      print_preload: null,
      table_draft_preloader: false,
      table_ready_preloader: false,
      table_cash_preloader: false,
      table_bank_preloader: false,
    }
  },
  validations: {
    form: {
      storekeeper: {
        required: requiredIf(function() {
          return !this.is_product_storage_storekeeper
        })
      },
      buyer: { required },
      supplier: { required },
    },
  },
  computed: {
    is_product_storage_storekeeper() {
      return this.$store.state.userGroups.some(group => group.code === 'product_storage_storekeeper')
    },
    is_product_storage_manager() {
      return this.$store.state.userGroups.some(group => group.code === 'product_storage_manager')
    },
    is_product_storage_supervisor() {
      return this.$store.state.userGroups.some(group => group.code === 'product_storage_supervisor')
    },
    is_general_manager() {
      return this.$store.state.userGroups.some(group => group.code === 'general_manager')
    }
  },
  created() {
    this.fetchItemsDraft()
    this.fetchItemsReady()
    this.fetchItemsCash()
    this.fetchItemsBank()
    if (!this.is_product_storage_storekeeper) {
      getEmployeesListSearch({
        position: 'product_keeper',
        employment_status: 'working'
      })
        .then(response => {
          this.employee_options = response.data
          if (response.data.length) this.form.storekeeper = response.data[0].id
        })
    }
    getEmployeesListSearch({
      position: 'product_buyer',
      employment_status: 'working'
    })
      .then(response => {
        this.buyer_options = response.data
        if (response.data.length) this.form.buyer = response.data[0].id
      })
    getSuppliersProduct().then(response => {
      this.supplier_options = response.data
      this.is_loaded = true
    })
  },
  watch: {
    checked_all(value) {
      if (value) {
        this.table_cash.items.forEach(item => {
          if ((!item.cash_request) && !this.checked.includes(item.id)) this.checked.push(item.id)
        })
      } else {
        this.checked = []
      }
    },
    checked(value) {
      this.is_show_flying_block = value.length > 0
      if (!this.checked.length) this.checked_all = false
    },
  },
  methods: {
    onFilterProducts() {
      this.search = ''
      this.pagination.page = 1
      this.pagination_ready.page = 1
      this.pagination_cash.page = 1
      this.pagination_bank.page = 1
      this.fetchItemsDraft()
      this.fetchItemsReady()
      this.fetchItemsCash()
      this.fetchItemsBank()
    },
    onPrint(row) {
      this.print_preload = `print_${row.payment_method.code}_${row.id}`
      getOrderPrint(row.id)
        .finally(() => { this.print_preload = null })
        .then(response => { window.open(response.data) })
    },
    onShowModal() {
      this.$modal.show('client-form')
    },
    onCloseModal() {
      this.$modal.hide('client-form')
      this.form = {}
      this.$v.form.$reset()
    },
    onPaymentCreate() {
      this.$refs.submitPayment.preload = true
      postProductStorageCashRequests({ entity: 'orders', orders: this.checked })
        .finally(() => { this.$refs.submitPayment.preload = false })
        .then(() => {
          this.checked_all = false
          this.checked = []
          this.fetchItemsCash()
          this.$notify({
            type: 'success',
            title: 'Cash request created. Get the money in the accounting department.',
          })
        })
    },
    onClickPagination(page) {
      this.table_draft_preloader = true
      this.pagination.page = page
      this.fetchItemsDraft()
    },
    onClickPaginationReady(page) {
      this.table_ready_preloader = true
      this.pagination_ready.page = page
      this.fetchItemsReady()
    },
    onClickPaginationCash(page) {
      this.table_cash_preloader = true
      this.pagination_cash.page = page
      this.fetchItemsCash()
    },
    onClickPaginationBank(page) {
      this.table_bank_preloader = true
      this.pagination_bank.page = page
      this.fetchItemsBank()
    },
    dateFormat(date) {
      return format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy')
    },
    fetchItemsDraft() {
      getOrdersProduct({
        page: this.pagination.page,
        page_size: 20,
        search: this.search,
        status: 'draft',
        supplier: this.search ? '' : this.filter_suppliers
      })
        .then(response => {
          this.table.items = response.data.results
          this.pagination.pages = response.data.pages
          this.pagination.count = response.data.count
          this.table_draft_preloader = false
        })
    },
    fetchItemsReady() {
      getOrdersProduct({
        page: this.pagination_ready.page,
        page_size: 20,
        search: this.search,
        status: 'ready',
        supplier: this.search ? '' : this.filter_suppliers
      })
        .then(response => {
          this.table_ready.items = response.data.results
          this.pagination_ready.pages = response.data.pages
          this.pagination_ready.count = response.data.count
          this.table_ready_preloader = false
        })
    },
    fetchItemsCash() {
      getOrdersProduct({
        page: this.pagination_cash.page,
        page_size: 20,
        search: this.search,
        status: 'in_process',
        payment_method: 'cash',
        supplier: this.search ? '' : this.filter_suppliers
      })
        .then(response => {
          this.table_cash.items = response.data.results
          this.pagination_cash.pages = response.data.pages
          this.pagination_cash.count = response.data.count
          this.table_cash_preloader = false
        })
    },
    fetchItemsBank() {
      getOrdersProduct({
        page: this.pagination_bank.page,
        page_size: 20,
        search: this.search,
        status: 'in_process',
        payment_method: 'bank',
        supplier: this.search ? '' : this.filter_suppliers
      })
        .then(response => {
          this.table_bank.items = response.data.results
          this.pagination_bank.pages = response.data.pages
          this.pagination_bank.count = response.data.count
          this.table_bank_preloader = false
        })
    },
    onOrdersSearch() {
      this.searchUsers(this)
    },
    searchUsers: debounce(vm => {
      vm.pagination.page = 1
      vm.pagination_ready.page = 1
      vm.pagination_cash.page = 1
      vm.pagination_bank.page = 1
      vm.fetchItemsDraft()
      vm.fetchItemsReady()
      vm.fetchItemsCash()
      vm.fetchItemsBank()
    }, 350),
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      const data = {...this.form}
      if (this.is_product_storage_storekeeper) data.storekeeper = this.$store.state.userData.employee.id
      postProductStorageOrder(data)
        .finally(() => { this.$refs.submit.preload = false })
        .then(response => {
          this.$notify({
            type: 'success',
            title: 'Order created',
          })
          this.$router.push({ name: 'product-storage-order-detail', params: { id: response.data.id } })
        })
    },
  }
}
</script>
